import { Box, Button, Grid, Typography, styled } from "@mui/material";
import logo from "@/assets/sdcp-logo-white.png";
import {
  programs,
  Card,
  CardImage,
  CardOverlay,
  StatusChip,
  OverlayRow,
} from "@/utils/landingPrograms";
import SVGExternalArrow from "@/assets/icons/SVGExternalArrow";

const HeaderBar = styled(Box)(() => ({
  width: "100%",
  background: "#073B56",
  padding: "24px 0 16px 0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const LandingPage = () => {
  return (
    <Box sx={{ minHeight: "100vh", background: "#fff" }}>
      <HeaderBar>
        <img
          src={logo}
          alt="San Diego Community Power"
          style={{ height: 48, marginRight: 16 }}
        />
      </HeaderBar>
      <Box sx={{ maxWidth: 1200, mx: "auto", mt: 6, p: 3 }}>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 600,
            fontSize: { xs: 28, md: 40 },
            textAlign: "center",
            color: "#13351A",
            mb: 1,
          }}
        >
          Welcome to the Solar Battery Savings Portal
        </Typography>
        <Typography sx={{ textAlign: "center", mb: 5, color: "#222" }}>
          Please select the program portal you would like to log in to:
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {programs.map((program) => (
            <Grid item xs={12} md={6} key={program.title}>
              <Card>
                <CardImage src={program.image} alt={program.title} />
                <CardOverlay>
                  <OverlayRow>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <StatusChip
                        variant={
                          program.status.includes("Accepting")
                            ? "filled"
                            : "outlined"
                        }
                      >
                        {program.status}
                      </StatusChip>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: 13,
                          mb: 1.5,
                          color: "#222",
                          lineHeight: 1.2,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {program.title}
                      </Typography>
                      <Typography
                        sx={{ color: "#222", fontSize: 12, lineHeight: 1.2 }}
                      >
                        {program.description}
                      </Typography>
                    </Box>
                    <Button
                      variant="outlined"
                      startIcon={
                        <SVGExternalArrow style={{ width: 18, height: 18 }} />
                      }
                      href={program.url}
                      target="_blank"
                      sx={{
                        borderRadius: 999,
                        fontSize: "12px !important",
                        px: "10px !important",
                        py: "0 !important",
                        height: "28px !important",
                        minWidth: "0 !important",
                        minHeight: "0 !important",
                        whiteSpace: "nowrap",
                        color: "#23272F",
                        border: "1px solid #B0B7C3",
                        "& .MuiButton-startIcon": {
                          marginRight: 0,
                        },
                      }}
                    >
                      {program.buttonLabel}
                    </Button>
                  </OverlayRow>
                </CardOverlay>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default LandingPage;
